import GSAP from 'gsap';
import { each } from 'lodash';

export default class Button {
    constructor(element) {
        this.element = element;

        this.manipulation(this.element);
    }

    manipulation(target){
        this.label = document.createElement('span')
        this.wrapper = document.createElement('span')
            
        this.label.innerHTML = target.innerHTML // Insert text in <span>

        var clone = this.label.cloneNode(true)

        target.innerHTML = ''

        target.append(this.wrapper)
        this.wrapper.append(this.label)
        this.wrapper.append(clone)

        this.fixLineHeight()
        window.addEventListener('resize', this.onResize);
    }

    fixLineHeight = () => {
        var objectHeight = this.label.offsetHeight
        var fontSize = window.getComputedStyle(this.label).fontSize
        var lineHeight = parseInt(fontSize)
        var lines = objectHeight / lineHeight
        var newHeight = objectHeight + (fontSize)

        if(objectHeight < lineHeight){
            this.wrapper.style.height = `${lineHeight + (lineHeight * 0.2)}px`
        } else {
            this.wrapper.style.height = `${objectHeight + (lineHeight * 0.2)}px`
        }
    }

    onMouseEnter(){
        // this.timeline.play();
    }

    onMouseLeave(){
        // this.timeline.reverse();
    }

    onResize = () => {
        this.fixLineHeight();
    }

    addEventListeners() {
        // this.onMouseEnterEvent = this.onMouseEnter.bind(this);
        // this.onMouseLeaveEvent = this.onMouseLeave.bind(this);

        // this.element.addEventListener('mouseenter', this.onMouseEnterEvent);
        // this.element.addEventListener('mouseleave', this.onMouseLeaveEvent);
    }

    removeEventListeners() {
        // this.element.removeEventListener('mouseenter', this.onMouseEnter);
        // this.element.removeEventListener('mouseleave', this.onMouseLeave);
    }
}
